import React, { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { red } from "@mui/material/colors";
import NoRowItem from "../NoItemRow";
import AccordionCell from "../AccordionCell";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Chip from "@mui/material/Chip";


const TableItemRow = ({ ...props }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [statusColor, setStatusColor] = useState("info");
  
  const setColor = () => {
    const statusColorMap = {
      READY_FOR_REVIEW: "warning",
      DELIVERED: "success",
      DONE: "info",
      DELETE: "error",
    };
    setStatusColor(statusColorMap[props.order.orderStatus] || "info");
  }

  useEffect(() => {
    setColor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    props.updateOrderStatus(props.order.id, status)
    setAnchorEl(null);
  };

  const formatDate = (dateTime) => {
    const dateString = dateTime;
    const date = new Date(dateString);
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return formattedDate;
  }
  const formattedDate = formatDate(props.order.orderDate);

  return (
    <React.Fragment>
      <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
        <AccordionCell
          isUserOrderOpen={props.isUserOrderOpen}
          isOpen={props.isOpen}
          row={props.order}
          openUserProducts={props.openUserProducts}
        />
        <TableCell align="right">
          {props.order.id ? props.order.id : "No data"}
        </TableCell>
        <TableCell align="center">
          <Button
            id="basic-button"
            onClick={() => props.getUserById(props.order.clientId)}
            >
              Client info
            </Button>
        </TableCell>
        <TableCell align="right">
          {props.order.orderDate ? formattedDate : "No data"}
        </TableCell>
        <TableCell align="center">
          <Chip 
            label={props.order.orderStatus ? props.order.orderStatus : "No data"}
            variant="outlined"
            color={statusColor}
          />
        </TableCell>
        <TableCell align="center">
          {props.order.orderPrice ? `${props.order.orderPrice} CHF` : "No data"}
        </TableCell>
        <TableCell align="center">
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            >
              Change
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem onClick={() => handleClose('READY_FOR_REVIEW')}>READY_FOR_REVIEW</MenuItem>
              <MenuItem onClick={() => handleClose('DELIVERED')}>DELIVERED</MenuItem>
              <MenuItem onClick={() => handleClose('DONE')}>DONE</MenuItem>
              <MenuItem onClick={() => handleClose('DELETE')}>DELETE</MenuItem>
            </Menu>

        </TableCell>
        <TableCell align="center">
          {props.order.id ?
            <DeleteIcon
              sx={{ color: red[800] }}
              style={{ cursor: "pointer" }}
              onClick={() => props.deleteOrder(props.order.id)}
            />
            : 
            "No data"
          }
        </TableCell>
      </TableRow>
      {props.isOpen === props.order.id ? (
        props.orderProducts && props.orderProducts.length > 0 ? (
          props.orderProducts.map((row) => (
            <TableRow
              key={`${row.name}_${row.id}`}
              className="product-from-group"
            >
              <TableCell align="right">
                <em>Product</em>
              </TableCell>
              <TableCell align="right">{row.id ? row.id : "No data"}</TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right">
                {row.name ? row.name : "No data"}
              </TableCell>
              <TableCell align="center">
                <strong>Ordered:</strong> <em>{row.quantity ? row.quantity : "No data"}</em>
              </TableCell>
              <TableCell align="center">
                <strong>On stock:</strong> <em>{row.stock ? row.stock : "No data"}</em>
              </TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          ))
        ) : (
          <NoRowItem/>
        )
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default TableItemRow;
